module.exports = __webpack_public_path__ + "img/unicredit-medium.5c485302.svg";